define('utils/common',['jquery', 'utils/template'], function ($) {

	if (typeof Notification != "undefined" && Notification.permission !== "granted")
		Notification.requestPermission();
	
	String.prototype.rot13 = function() {
		return this.replace(/[a-zA-Z]/g, function(c) {
			return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
		});
	};
	
	// Str_replace equivalent
	String.prototype.replaceAll = function (key, replace) {
		return this.split(key).join(replace);
	};
	
	// Html specialchars
	String.prototype.htmlspecialchars = function () {
		return $('<p>').text(this).html();
	};
	
	// Array remove shortcut
	Array.prototype.remove = function(from, to) {
	  var rest = this.slice((to || from) + 1 || this.length);
	  this.length = from < 0 ? this.length + from : from;
	  return this.push.apply(this, rest);
	};

	jQuery.extend({
		
		/**
		 * Flash message script!
		 * @param message Message to show
		 * @param cls Class of notification. success|error|general
		 */
		message : function (message, cls) {
			if(cls == undefined) 
				cls = 'error';
			
			var c = $('#notification-container');
			var div = $('<div>').addClass('notification '+cls).html(message);
			c.append(div);
			div.fadeIn(0);			
			div.delay(5000).fadeOut(750, function () {
				$(this).remove();
			});
			
		},
		
		/**
		 * @returns Get current user id
		 */
		userId : function () {
			return parseInt($('meta[name=userid]').attr("content"));
		},
		
		/**
		 * Confirm box 
		 * @param callback_ok
		 * @param text
		 * @param callback_fail
		 * @returns q
		 */
		confirmBox : function (callback_ok, text, callback_fail) {
			text = text == undefined ? 'Weet u het zeker?' : text;
			var q = confirm(text);
			if(q) {
				if($.isFunction(callback_ok)) callback_ok.call(this);
			} else {
				if($.isFunction(callback_fail)) callback_fail.call(this);
			}
			
			return q;
		},
		
		/**
		 * CHtml::normalizeURL variant voor javascript
		 * @param url
		 * @param data
		 * @param defaults_overruling
		 * @returns formatted url
		 */
		url : function (url, data, defaults_overruling) {
			
			if(url.substr(0,4) == 'http')
				return url;
			
			var settings = {
				module : null,
				controller : null,
				action : null,
				
				parse : true,
				phpFile : ''
			};
			
			// parse given url to modus
			var urlparser = url.split('/');
			var offset = 0;
			
			// in the case index-test.php is in the given url...
			if(urlparser[0] == "" && urlparser[1].indexOf('.php') > 0) {
				urlparser = urlparser.slice(2);
				settings.parse = false;
				offset = 0;
			}
			
			if(urlparser[offset] == '') {
				settings.parse = false;
				urlparser.splice(0, 1);
			}
			
			// parse url to module, controller and action
			if(urlparser.length == (offset + 1)) {
				settings.action = urlparser[offset + 0];
			} else if(urlparser.length == (offset + 2)) { // controller en action
				settings.controller = urlparser[offset + 0];
				settings.action = urlparser[offset + 1];
			} else if(urlparser.length == (offset + 3)) { // module controller en action
				settings.module = urlparser[offset + 0];
				settings.controller = urlparser[offset + 1];
				settings.action = urlparser[offset + 2];
			}
			
			// parse current href to offset and other options
			var src = (window.location.href.substring($('meta[name=base]').attr('content').length )).split('/');
			
			var offset = 0;
			$.each(src, function (i, el) {
				if(this.indexOf('.php') > 0) {
					offset = i + 1;
					settings.phpFile = this;
				}
			});
			
			// set info when not set
			if(settings.module == null) 
				settings.module = src[offset];
			
			if(settings.controller == null)
				settings.controller = src[offset+1];

			// adding defaults
			if(defaults_overruling != undefined)
				settings = $.extend(settings, defaults_overruling);
			
			// rebuild URL
			var retUrl = [];
			
			// phpFile
			if(settings.phpFile != '') 
				retUrl.push(settings.phpFile);

			if(settings.parse) {
				if (settings.module != '')
					retUrl.push(settings.module);
				
				retUrl.push(settings.controller);
				retUrl.push(settings.action);
			} else {
				retUrl.push(urlparser.join('/'));
			}
			
			// creating /[key]/[val]
			if(data != undefined)
				$.each(data, function (key, val) {
					if(!$.isNothing(val)) {
						retUrl.push(key);
						retUrl.push(val);
					}
				});
			
			// return and join
			return $('meta[name=base]').attr('content')+retUrl.join('/');
		},
		
		isNothing : function (a) {
			return a == null || a == undefined || a == "";
		}
	});

	// checks of items exists
	$.fn.exists = function () {
		return $(this).length > 0;
	};
	
	// short cut for formatting dates
	$.fn.setDatetime = function (date) {
		
		var dobj = date;
		if(!(date instanceof Date)) {
			dobj = $.timeago.parse(date);
		}
		
		var el = $(this);
		
		function z(d) {
			return d < 10 ? '0' + d : d;
		}
		
		if(el.is('time')) {
			var format = dobj.getFullYear() + '-' + z(dobj.getMonth()+1).toString() + '-' + z(dobj.getDate()) + 'T' + z(dobj.getHours()) + ':' + z(dobj.getMinutes()) + ':' + z(dobj.getSeconds());	
			el.attr('datetime', format);
		}
		
		return el;
	};


});
